import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';

interface DiaVencimiento {
  id: number;
  dia: number;
  descripcion: string;
  activo: number;
  terminaciones: number[];
}

@Component({
  selector: 'app-vencimientos',
  templateUrl: './vencimientos.component.html',
  styleUrls: ['./vencimientos.component.css']
})
export class VencimientosComponent implements OnInit {

  diasVencimiento: DiaVencimiento[] = [];
  loading: boolean = false;

  // Formulario de nuevo día
  nuevoDiaVencimiento: number = 9;
  nuevaDescripcion: string = '';
  terminacionesDisponibles: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.cargarVencimientos();
  }

  cargarVencimientos() {
    this.loading = true;
    this.http.get<DiaVencimiento[]>(`${environment.backendUrl}/api/vencimientos`)
      .subscribe(
        data => {
          this.diasVencimiento = data;
          this.loading = false;
          console.log('[Vencimientos] Configuración cargada:', data);
        },
        error => {
          console.error('[Vencimientos] Error al cargar:', error);
          this.snackBar.open('Error al cargar la configuración de vencimientos', 'Cerrar', {
            duration: 3000
          });
          this.loading = false;
        }
      );
  }

  agregarDiaVencimiento() {
    if (this.nuevoDiaVencimiento < 1 || this.nuevoDiaVencimiento > 31) {
      this.snackBar.open('El día debe estar entre 1 y 31', 'Cerrar', { duration: 3000 });
      return;
    }

    // Verificar que no exista ya ese día
    if (this.diasVencimiento.some(v => v.dia === this.nuevoDiaVencimiento)) {
      this.snackBar.open('Ya existe un vencimiento para ese día', 'Cerrar', { duration: 3000 });
      return;
    }

    const nuevoDia: DiaVencimiento = {
      id: 0,
      dia: this.nuevoDiaVencimiento,
      descripcion: this.nuevaDescripcion || `Vencimiento día ${this.nuevoDiaVencimiento}`,
      activo: 1,
      terminaciones: []
    };

    this.diasVencimiento.push(nuevoDia);
    this.diasVencimiento.sort((a, b) => a.dia - b.dia);

    this.nuevoDiaVencimiento = 9;
    this.nuevaDescripcion = '';

    this.snackBar.open('Día agregado. Recuerde guardar los cambios.', 'Cerrar', { duration: 2000 });
  }

  eliminarDiaVencimiento(dia: DiaVencimiento) {
    if (!confirm(`¿Está seguro de eliminar el día ${dia.dia}?`)) {
      return;
    }
    this.diasVencimiento = this.diasVencimiento.filter(v => v.dia !== dia.dia);
    this.snackBar.open('Día eliminado. Recuerde guardar los cambios.', 'Cerrar', { duration: 2000 });
  }

  agregarTerminacion(dia: DiaVencimiento, terminacion: number) {
    if (dia.terminaciones.includes(terminacion)) {
      return;
    }

    // Verificar que no esté en otro día
    const otroDia = this.diasVencimiento.find(v => v.dia !== dia.dia && v.terminaciones.includes(terminacion));
    if (otroDia) {
      this.snackBar.open(`La terminación ${terminacion} ya está asignada al día ${otroDia.dia}`, 'Cerrar', { duration: 3000 });
      return;
    }

    dia.terminaciones.push(terminacion);
    dia.terminaciones.sort((a, b) => a - b);
  }

  eliminarTerminacion(dia: DiaVencimiento, terminacion: number) {
    dia.terminaciones = dia.terminaciones.filter(t => t !== terminacion);
  }

  getTerminacionesDisponibles(): number[] {
    const asignadas = new Set<number>();
    this.diasVencimiento.forEach(dia => {
      dia.terminaciones.forEach(t => asignadas.add(t));
    });

    return this.terminacionesDisponibles.filter(t => !asignadas.has(t));
  }

  guardarConfiguracion() {
    // Validar que todas las terminaciones 0-9 estén asignadas
    const todasTerminaciones = new Set<number>();
    this.diasVencimiento.forEach(dia => {
      dia.terminaciones.forEach(t => todasTerminaciones.add(t));
    });

    for (let i = 0; i <= 9; i++) {
      if (!todasTerminaciones.has(i)) {
        this.snackBar.open(`Falta asignar la terminación ${i}`, 'Cerrar', { duration: 3000 });
        return;
      }
    }

    this.loading = true;

    const configuracion = this.diasVencimiento.map(dia => ({
      dia: dia.dia,
      descripcion: dia.descripcion,
      terminaciones: dia.terminaciones
    }));

    this.http.post(`${environment.backendUrl}/api/vencimientos`, configuracion)
      .subscribe(
        () => {
          this.snackBar.open('Configuración guardada correctamente', 'Cerrar', { duration: 3000 });
          this.cargarVencimientos();
        },
        error => {
          console.error('[Vencimientos] Error al guardar:', error);
          this.snackBar.open('Error al guardar la configuración', 'Cerrar', { duration: 3000 });
          this.loading = false;
        }
      );
  }

  cancelarCambios() {
    if (confirm('¿Descartar los cambios no guardados?')) {
      this.cargarVencimientos();
    }
  }

  formatearPorcentaje(valor: number): string {
    return (valor * 100).toFixed(2) + '%';
  }
}
